











import { Sort } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';

@Component
export default class SortToggle extends Vue {
  @Prop({ required: true })
  selectedSort: Sort;

  @Prop({ required: true })
  expanded: boolean;

  onClick() {
    this.$x.emit(EVENTS.SortToggleClicked);
  }

}
